<div class="store-group-select-container">
  <mat-form-field class="select-trigger" (click)="toggleDropdown()" [class.open]="isOpen">
    <input matInput
           readonly
           [placeholder]="'brand.storeGroups.title' | translate"
           [value]="getSelectedLabel()">
    <i matSuffix [ngClass]="isOpen ? 'tce-icon-dropdown-open' : 'tce-icon-dropdown-closed'"></i>
    <mat-hint>{{ 'brand.storeGroups.filterStores' | translate }}</mat-hint>
  </mat-form-field>

  <div class="dropdown-panel mat-elevation-z4" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <div class="panel-header">
      <span class="header-title">{{ 'brand.storeGroups.title' | translate }}</span>
      <div class="view-toggle">
        <button [class.active]="viewMode === 'list'" (click)="setViewMode('list')">List</button>
        <button [class.active]="viewMode === 'tree'" (click)="setViewMode('tree')">Tree</button>
      </div>
    </div>

    <div class="panel-content">
      <txp-loading *ngIf="isLoading" [color]="loadingColor.COLOR"></txp-loading>

      <div class="list-view" *ngIf="!isLoading && viewMode === 'list'">
        <div class="list-item" *ngFor="let group of flattenedGroups" (click)="toggleGroup(group.id)">
          <mat-checkbox [checked]="isSelected(group.id)" (click)="$event.stopPropagation(); toggleGroup(group.id)"></mat-checkbox>
          <span class="group-name">{{ group.name }}</span>
        </div>
      </div>

      <div class="tree-view" *ngIf="!isLoading && viewMode === 'tree'">
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="20">
            <div class="tree-toggle-spacer"></div>
            <div class="tree-node-content" (click)="toggleGroup(node.id)">
              <mat-checkbox [checked]="isSelected(node.id)" (click)="$event.stopPropagation(); toggleGroup(node.id)"></mat-checkbox>
              <span class="node-name">{{ node.name }}</span>
            </div>
          </mat-tree-node>

          <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding [matTreeNodePaddingIndent]="20">
            <txp-button matTreeNodeToggle
                        class="mat-tree-node-toggle"
                        [size]="buttonSize.EXTRA_SMALL"
                        [style]="buttonStyle.ROWACTION"
                        [icon]="treeControl.isExpanded(node) ? 'tce-icon-dropdown-open' : 'tce-icon-dropdown-closed'"
                        [attr.aria-label]="'Toggle ' + node.name">
            </txp-button>
            <div class="tree-node-content" (click)="toggleGroup(node.id)">
              <mat-checkbox [checked]="isSelected(node.id)" (click)="$event.stopPropagation(); toggleGroup(node.id)"></mat-checkbox>
              <span class="node-name">{{ node.name }}</span>
            </div>
          </mat-tree-node>
        </mat-tree>
      </div>
    </div>
  </div>
</div>

<div class="overlay-backdrop" *ngIf="isOpen" (click)="closeDropdown()"></div>
